/**
 * 微应用 URL 处理工具
 * 在开发环境中将外部 URL 转换为代理路径，避免 CORS 问题
 * 在生产环境中将 HTTP URL 转换为 HTTPS，避免 Mixed Content 错误
 */

/**
 * 将外部 URL 转换为代理路径（开发环境）或 HTTPS（生产环境）
 * @param url 原始 URL
 * @returns 转换后的 URL
 */
export function normalizeMicroAppUrl(url: string | undefined): string | undefined {
  if (!url) return url

  const isDevelopment = process.env.NODE_ENV === 'development'
  const assetSitDomain = 'asset-sit.haier.net'

  // 检查是否是 asset-sit.haier.net 的 URL
  if (!url.includes(assetSitDomain)) {
    return url
  }

  try {
    const urlObj = new URL(url)
    const pathname = urlObj.pathname

    if (isDevelopment) {
      console.log('进入开发模式，将外部 URL 转换为代理路径');
      // 开发环境：将外部 URL 转换为代理路径
      // 例如：https://asset-sit.haier.net/subapplication -> /subapplication
      // 例如：http://asset-sit.haier.net/frontendasset -> /frontendasset
      return pathname || '/'
    } else {
      console.log('进入生产模式，将 HTTP URL 转换为 HTTPS');
      // 生产环境：将 HTTP URL 转换为 HTTPS，避免 Mixed Content 错误
      if (urlObj.protocol === 'http:') {
        urlObj.protocol = 'https:'
        return urlObj.toString()
      }
      return url
    }
  } catch (e) {
    // 如果 URL 解析失败，尝试使用字符串替换的方式
    if (isDevelopment) {
      console.log('进入开发模式，提取路径部分');
      // 开发环境：提取路径部分
      const match = url.match(/https?:\/\/asset-sit\.haier\.net(\/.*)/)
      if (match && match[1]) {
        return match[1]
      }
    } else {
      console.log('进入生产模式，将 HTTP 转换为 HTTPS');
      // 生产环境：将 HTTP 转换为 HTTPS
      if (url.startsWith('http://') && url.includes(assetSitDomain)) {
        return url.replace('http://', 'https://')
      }
    }
    return url
  }
}

